import { computed } from 'vue';
import { useStore } from '~/store';

export default function useCommandLaunch() {
  const store = useStore();

  /**
   * Get last command launch
   */
  const lastCommandLaunch = computed(() => store.getters['commands/getCommandLaunch']);
  /**
   * Get last command launch ID
   */
  const commandLaunchId = computed(() => store.getters['commands/getCommandLaunchId']);

  /**
   * Update a changeover
   */
  const putChangeover = (changeover) => store.dispatch('events/putChangeover', changeover);
  /**
   * Save the command launch id to display in the store
   */
  const commitCommandLaunchId = (id) => store.commit('commands/commitCommandLaunchId', id);
  /**
   * Update changeover and save the command id associate
   * The command id can be updated if a new command is create
   */
  const updateChangeoverSaveCommand = async (changeover) => {
    const changeoverUpdated = await putChangeover(changeover);
    // Saving the command launch id to display in the store
    commitCommandLaunchId(changeoverUpdated.clTrigger);
  };

  /**
   * Turn the automatic counting off for a changeover and its machine,
   * and save the command id associated
   */
  const disableCountingSaveCommand = async (changeoverId) => {
    const changeoverUpdated = await store.dispatch('events/disableChangeoverCounting', changeoverId);
    commitCommandLaunchId(changeoverUpdated.clTrigger);
  };

  return {
    commandLaunchId,
    lastCommandLaunch,
    putChangeover,
    commitCommandLaunchId,
    updateChangeoverSaveCommand,
    disableCountingSaveCommand,
  };
}
